import React, { useState } from 'react';
import AnomalyCard from '../components/home/AnomalyCard';
import HealthScoreCard from '../components/home/HealthScoreCard';
import TodayCard from '../components/home/TodayCard';
import CompletenessCard from '../components/home/CompletenessCard';
import StackConfirmCard from '../components/supplements/StackConfirmCard';

// Home — the calm daily cockpit (glance layer). The report-card score + a
// tap-through summary of today's log. The twin moved to /you; logging is the
// bottom-nav mic (/log); the full log lives in entries (nested under Data).
//
// AnomalyCard sits above everything because it is the one thing here that is
// occasionally urgent and always rare: several signals in one system moving
// together over a fortnight. On the ~29 days a month it has nothing to report
// it says so in a line, which is what makes its silence trustworthy rather than
// indistinguishable from a broken feature.

const HomePage = () => {
  // Answering an anomaly changes what the rest of the page should show (the
  // score's inputs are the same numbers), so a resolution refreshes the stack.
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <AnomalyCard onResolved={() => setRefreshKey((k) => k + 1)} />
      <HealthScoreCard refreshKey={refreshKey} />
      <TodayCard />
      <StackConfirmCard />
      <CompletenessCard />
    </div>
  );
};

export default HomePage;
